import React from 'react';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'pink' | 'white' | 'aqua';
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ 
  size = 'md', 
  color = 'pink', 
  text 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-4',
    lg: 'w-12 h-12 border-4'
  };

  const colorClasses = {
    pink: 'border-brand-pink border-t-transparent',
    white: 'border-white border-t-transparent',
    aqua: 'border-brand-aqua border-t-transparent'
  };

  return (
    <div className="flex flex-col items-center gap-3">
      <div
        className={`${sizeClasses[size]} ${colorClasses[color]} rounded-full animate-spin`}
      />
      {text && (
        <span className="text-[10px] font-black uppercase tracking-widest text-brand-pink animate-pulse">
          {text}
        </span>
      )}
    </div>
  );
};

export default Loader;
